import ChoiceCard, { type ChoiceCardBaseProps } from './ChoiceCard';

const CheckboxCard = (props: ChoiceCardBaseProps) => <ChoiceCard type="checkbox" {...props} />;

export default CheckboxCard;
